import { useMemo } from 'react'

import useTicketStatsQuery from 'src/hooks/services/servicenow/queries/useTicketStatsQuery'

import Button from 'src/components/Common/Button'
import PieGraph from '~/components/Graphs/PieGraph'

import { useNavigate } from 'react-router-dom'

import { Tile, TileContent, TileHeader } from '../Tile'

const TicketsByPriorityTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading: isTicketStatsLoading } = useTicketStatsQuery({
    groupBy: 'priority',
    stateFilter: ['Open']
  })

  const chartData = useMemo(() => {
    if (!ticketStats) return []

    return Object.entries(ticketStats).map(([priority, count]) => ({
      name: priority.charAt(0).toUpperCase() + priority.slice(1).replace(/_/g, ' '),
      value: count,
      onClick: () => navigate(`/tickets?priority=${priority}`)
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(ticketStats), navigate])

  return (
    <Tile className="select-none">
      <TileHeader loading={isTicketStatsLoading}>
        <TileHeader.Title>Open Tickets</TileHeader.Title>
        <TileHeader.Subtitle>Grouped by Priority</TileHeader.Subtitle>
        <TileHeader.Item>
          <Button bordered className="duration-100 hover:bg-th-content-secondary" onMouseDown={() => navigate('/tickets')}>
            View All Tickets
          </Button>
        </TileHeader.Item>
      </TileHeader>

      <TileContent>
        <PieGraph data={chartData} legend={false} shouldFormatCurrency={false} />
      </TileContent>
    </Tile>
  )
}

export default TicketsByPriorityTile
